<template>
    <div>
        <div class="w-full flex-col shadow-md pb-2 mb-4 bg-white rounded mr-8">
            <div class="flex border-b-2 border-followup-nav text-grey-darkest rounded-t p-2 justify-between">
                <span class="pl-2">Activities</span>
            </div>
            <div class="pt-4 pb-2 px-3 lg:w-2/3 mb-4 mt-lg-0">
                <div class="flex mb-2 inline-block">
                    <div v-if="followupDate" class="col-1 px-1 flex items-center">
                        <input
                               type="checkbox"
                               id="followup-complete"
                               name="followup-complete"
                               true-value="1"
                               false-value="0"
                               class="sales-behavior-checkbox"
                               :use-utc="true"
                               v-model="followupComplete"
                               @change="followupDateToParent();checkIsSalesActivityCompleted({completed: followupComplete, name: 'Follow Up'});"
                        />
                    </div>
                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                    :class="followupDate ? 'col-5' : 'col-6'">Follow Up</label>
                    <div class="flex px-1" v-show="!hasCalendarAccess"
                    :class="followupDate ? 'col-5' : 'col-6'">
                        <!-- <datepicker v-model="followupDate"
                                    @keypress.enter.prevent="closeCalendar()"
                                    format="MM/d/yyyy"
                                    :use-utc="true"
                                    :week-start="7"
                                    :wrapper-class="followupDate ? 'fullscreen-when-on-mobile w-4/5' : 'fullscreen-when-on-mobile w-full'"
                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                    @input="followupDateToParent">
                        </datepicker>
                        <button type="button" v-if="followupDate"
                                @click="removeFollowUpDate"
                                class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                        </button> -->
                        <datetime type="date"
                                    v-model="followupDate"
                                    :use-utc="true"
                                    class="w-full"
                                    :week-start="7"
                                    :format="masks.date_mask"
                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                    @input="followupDateToParent">
                        </datetime>
                        <button type="button" v-if="followupDate"
                                @click="removeFollowUpDate"
                                class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                        </button>
                    </div>
                    <div v-show="hasCalendarAccess" class="flex px-1"
                            :class="followupDate ? 'col-5' : 'col-6'">
                        <datetime type="datetime" name="date"
                                    v-model="followupDate" use12-hour
                                    class="w-full"
                                    :week-start="7"
                                    :format="masks.date_time_mask"
                                    :minute-step="15"
                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                    @input="followupDateToParent">
                        </datetime>
                        <button type="button" v-if="followupDate"
                                @click="removeFollowUpDate"
                                class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                        </button>
                    </div>

                    <div v-if="followupDate" class="text-teal cursor-pointer flex justify-center items-center col-1 px-1"
                            @click.prevent.stop="openFollowUpEmailModal">
                        <i class="fa fa-calendar"></i>
                    </div>
                </div>
                <div v-if="form.sales_behaviors.length > 0" v-for="(item, index) in form.sales_behaviors"
                        class="flex mb-2 inline-block" :key="index">
                    <div v-if="atLeastOneHasDate" class="col-1 px-1 flex items-center">
                        <input v-if="item.date && !item.follow_up"
                                type="checkbox"
                                id=""
                                name=""
                                true-value="1"
                                false-value="0"
                                class="sales-behavior-checkbox"
                                :use-utc="true"
                                :disabled="checkIfLockableActivity(item.id)"
                                v-model="item.completed"
                               @change="checkIsSalesActivityCompleted(item);"
                        />
                    </div>
                    <label class="text-grey-darkest text-sm px-1 mb-0 flex items-center"
                            :class="atLeastOneHasDate ? 'col-5' : 'col-6'">{{ item.name }}:</label>
                    <div v-show="hasCalendarAccess==false" class="flex px-1"
                            :class="atLeastOneHasDate ? 'col-5' : 'col-6'">
                        <!-- <datepicker v-model="item.date"
                                    @keypress.enter.prevent="closeCalendar()"
                                    :ref=item.name
                                    format="MM/d/yyyy"
                                    :use-utc="true"
                                    :week-start="7"
                                    :wrapper-class="item.date ? 'fullscreen-when-on-mobile w-4/5' : 'fullscreen-when-on-mobile w-full'"
                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                    :date-parser="dateParser"
                                    @input="testDate(item.date)">
                        </datepicker> -->
                        <datetime type="date"
                                    v-model="item.date"
                                    :use-utc="true"
                                    :ref=index
                                    class="w-full"
                                    :week-start="7"
                                    :format="masks.date_mask"
                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1">
                        </datetime>
                        <button type="button" v-if="item.date"
                                @click="removeDateTimePicker(index)"
                                class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                        </button>
                    </div>
                    <div v-show="hasCalendarAccess" class="flex px-1"
                            :class="atLeastOneHasDate ? 'col-5' : 'col-6'">
                        <datetime v-if="item.end_date" type="datetime" name="date"
                                    v-model="item.end_date" use12-hour
                                    :ref=item.name
                                    class="w-full"
                                    :week-start="7"
                                    :format="masks.date_time_mask"
                                    :minute-step="15"
                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                    @input="form.errors.clear('start_date')">
                        </datetime>
                        <datetime v-if="!item.end_date" type="datetime" name="date"
                                    v-model="item.date" use12-hour
                                    :ref=item.name
                                    class="w-full"
                                    :week-start="7"
                                    :format="masks.date_time_mask"
                                    :minute-step="15"
                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1"
                                    @input="form.errors.clear('start_date')">
                        </datetime>
                        <button type="button" v-if="item.date"
                                @click="removeDateTimePicker(index)"
                                class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                        </button>
                    </div>

                    <div v-if="item.date" class="text-teal cursor-pointer flex justify-center items-center col-1 px-1"
                            @click.prevent.stop="openEmailModal(item,contact.name)">
                        <i class="fa fa-calendar"></i>
                    </div>
                </div>
                <div v-if="form.sales_behaviors.length === 0" class="mb-2">
                    <div class="text-grey-darkest text-sm">
                        Your company does not currently have any contact behaviors.
                    </div>
                </div>
            </div>
            <div class="pt-4 pb-2 px-3 mb-4 mt-lg-0">
                <button v-if="canEdit || assignedUserID == this.currentUserId || assignedUserID == 0"
                    class="py-2 px-4 rounded-full flex flex-row items-center justify-center focus:outline-none hover:bg-teal-dark float-right"
                    :class="'bg-teal-dark cursor-not-allowed'" @click="saveActivities()" id="saveContactActivityButton">
                    <span class="text-white font-bold">Save</span>
                </button>
            </div>
        </div>
        <contact-external-calendar-file-modal ref="EmailFileModal" :team-id="teamId"></contact-external-calendar-file-modal>



        <div id="contactSaleBehaviorCompleteCommentModal" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog" style="max-width: 870px">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 v-if="tempSalesActivity" class="modal-title text-lg">
                            {{tempSalesActivity.name}} note
                        </h4>
                    </div>
                    <div class="modal-body">
                        <form>

                            <div class="mb-2">
                                <ckeditor-container placeholder="Add Note" id="comment" v-model="commentForm.note" :options="users"
                                                    @mention="addMention" mentionFrom="name"></ckeditor-container>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <span v-if="commentSaving">
                            <button type="button" disabled
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                <i class="fa fa-btn fa-spinner fa-spin"></i> Saving
                            </button>
                        </span>
                        <span v-else>
                            <button type="button" id="save-project-comment" name="save-project-comment"
                                    @click.prevent="contactSalesActivityCommentSaved"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                Save
                            </button>
                        </span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import Form from "../../utils/form";
import Datepicker from 'vuejs-datepicker';

export default {
    name: "contact-activities",
    props: ['company', 'contact', 'calendar', 'teamId', 'followUpSelectedDate', 'canEdit', 'currentUserId', 'assignedUserID', 'masks', 'currentUser', 'team',
            'agaveErp', 'residentialContactErpSyncSettings', 'vistaContactMapping', 'spectrumContactMapping', 'sageContactMapping', 'foundationMapping'],
    components: {Datepicker},
    data() {
        return {
            hasCalendarAccess: 0,
            form: new Form({
                contact: this.contact,
                user: this.contact.user ?? this.contact.last_meeting.user,
                sales_behaviors: [],
                oldContact: null,
                oldMeeting: null,
                oldCustomFieldValues: null,
                userTimeZoneName: null,
                userTimeZoneOffset: null
            }),
            followupDate: this.contact.last_meeting.date,
            followupComplete:(this.contact.last_meeting.completed)? this.contact.last_meeting.completed:0,
            completedContactActivitiesForSegment: [],
            tempSalesActivity: null,
            salesActivityComment: null,
            users: [],
            commentSaving: false,
            commentForm: new Form({
                note: '',
                noteId: 0,
                contact: this.contact,
                mentioned_users: []
            }),
        }
    },
    created() {
        this.hasCalendarAccess = this.calendar;
    },
    mounted() {
        this.fetchSalesBehaviors();
        Bus.$on('changeUserFormContact', data => {
            this.form.user =data;
        });
        Bus.$on('sendSaveRequest', data => {
            this.form.oldContact  = data.oldContact
            this.form.oldMeeting = data.oldMeeting
            this.form.oldCustomFieldValues = data.oldCustomFieldValues
            this.saved(data);
        });
    },
    computed: {
        atLeastOneHasDate() {
            return _.some(this.form.sales_behaviors, (item) => item.date);
        }
    },
    methods: {

        fetchSalesBehaviors() {
            let self = this;
            axios.get(route('contact.sales-behaviors', {contactId: self.contact.id})).then(({data}) => {
                self.form.sales_behaviors = data.data;
            });
        },

        checkIfLockableActivity(id) {
            const sb = _.find(this.form.sales_behaviors, {id: id, completed: 1, lockable_activity: 1});
            return !_.isEmpty(sb);
        },

        checkIsProposalDelivered(item) {
            if (item.proposal_delivered === 1 && item.completed === '1') {
                this.form.bid_date = item.date;
            }
        },

        openEmailModal(sales_behavior) {
            var project = {
                name: this.contact.name,
                id: this.contact.id,
                contact: this.contact
            };
            this.$refs.EmailFileModal.open(sales_behavior, project);
        },

        openFollowUpEmailModal() {
            var project = {
                name: this.contact.name,
                id: this.contact.id,
                contact: this.contact
            };
            var sales_behavior = {
                name: 'Followup',
                date: this.followupDate,
                end_date: null
            };
            this.$refs.EmailFileModal.open(sales_behavior, project);
        },

        removeFollowUpDate() {
            this.followupDate = null;
            this.followupDateToParent();
        },

        removeDateTimePicker(index) {
            this.form.sales_behaviors[index].date = null;
        },

        saved(data) {
            let self = this;
            self.form.userTimeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            self.form.userTimeZoneOffset = new Date().getTimezoneOffset();
            this.form.post(route('api.contact-behavior.store')).then((data) => {

                if(this.completedContactActivitiesForSegment.length > 0){
                    this.completedContactActivitiesForSegment.map(item => {
                        window.analytics.track('Contact Behavior Completed', {
                            projectName: this.form.name,
                            timestamp: moment().format('YYYY-MM-DD  h:mm:ss a'),
                            userName: this.currentUser.name,
                            userEmail: this.currentUser.email,
                            team: this.team.name,
                            contactBehavior: item
                        });
                    });
                }
                if(this.company.is_residential && this.agaveErp && this.isERPSyncSettingActionUpdate() && this.isResidentialContactERPSynced()) {
                    this.syncResidentialContactToEnabledERP();
                }
                else {
                    setTimeout(window.location.reload(), 1000)
                }
            }).catch((error) => {
                $('#saveContactActivityButton').attr("disabled", false);
                Bus.$emit('userRequiredError',error);
            });
        },

        followupDateToParent() {
            this.$nextTick(() => {
                Bus.$emit('sendFollowUpDate', {'followupDate': this.followupDate, 'followupComplete':this.followupComplete});
            });
        },

        saveActivities() {
            Bus.$emit('sendSaveActivities',this.form.sales_behaviors);
        },
        checkIsSalesActivityCompleted(item) {
            if(item.completed === '1'){
                this.completedContactActivitiesForSegment.push(item.name);
                if(item.complete_comment){
                    this.tempSalesActivity = item;
                    $('#contactSaleBehaviorCompleteCommentModal').modal('show');
                }
            }else {
                if(this.completedContactActivitiesForSegment.length > 0){
                    this.completedContactActivitiesForSegment = this.completedContactActivitiesForSegment.filter(x => x !== item.name)
                }
            }
        },
        addMention(){

        },
        contactSalesActivityCommentSaved(){
            this.commentForm.post(route('api.contact.note.store', {contact: this.contact})).then((resp) => {
                if (resp.status) {
                    this.getToast().fire({
                        type: 'success',
                        title: resp.message
                    });
                    window.location.reload();
                } else {
                    this.getToast().fire({
                        type: 'error',
                        title: 'Failed'
                    });
                }
                $('#contactSaleBehaviorCompleteCommentModal').modal('hide');
                this.commentForm.reset();
                this.saveActivities();
            }).catch((error) => {
                console.log('error', error);
            });
        },
        isERPSyncSettingActionUpdate() {
            let self = this;
            const settingIndex = _.findIndex(self.residentialContactErpSyncSettings, { 'entity_action': 'sync', 'entity_action_type': 'automatic', 'entity_action_depends_on': 'update' });

            return settingIndex !== -1;
        },
        isResidentialContactERPSynced() {
            if(this.agaveErp.third_party_name === 'vista' && this.contact.vista_customer_no
                && this.vistaContactMapping && this.vistaContactMapping.direction !== 'one-way-followup') {
                return true;
            }
            if(this.agaveErp.third_party_name === 'spectrum' && this.contact.spectrum_customer_no
                && this.spectrumContactMapping && this.spectrumContactMapping.direction !== 'one-way-followup') {
                return true;
            }
            if(this.agaveErp.third_party_name === 'foundationNew' && this.contact.foundation_customer_contact_no
                && this.foundationMapping && this.foundationMapping.direction !== 'one-way-followup') {
                return true;
            }
            if(this.agaveErp.third_party_name === 'sage-300-cre' && this.contact.sage_cre_customer_no
                && this.agaveErp.contact_field && this.agaveErp.contact_field.direction !== 'one-way-followup') {
                return true;
            }
            if(this.agaveErp.third_party_name === 'sage-100-contractor' && this.contact.sage_customer_no
                && this.sageContactMapping && this.sageContactMapping.direction !== 'one-way-followup') {
                return true;
            }
        },
        syncResidentialContactToEnabledERP() {
            if(this.agaveErp.third_party_name === 'vista' && this.contact.vista_customer_no) {
                this.$parent.$refs.ContactVistaComponent.connectOrUpdateVistaContact();
            }
            if(this.agaveErp.third_party_name === 'spectrum' && this.contact.spectrum_customer_no) {
                this.$parent.$refs.ContactSpectrumComponent.syncContactToAgave();
            }
            if(this.agaveErp.third_party_name === 'foundationNew' && this.contact.foundation_customer_contact_no) {
                this.$parent.$refs.foundationContactComponent.connectCustomerToFoundation();
            }
            if(this.agaveErp.third_party_name === 'sage-300-cre' && this.contact.sage_cre_customer_no) {
                this.$parent.$refs.Sage300Contact.syncContactToAgave();
            }
            if(this.agaveErp.third_party_name === 'sage-100-contractor' && this.contact.sage_customer_no) {
                this.$parent.$refs.sage100Contact.syncContactToAgave();
            }
        },
    }
}
</script>
